import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { ChaptersReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const chaptersReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...ChaptersReducerHandlers.fetchChaptersAndResourcesByProjectId,
    ...ChaptersReducerHandlers.fetchChaptersAndResourcesByUser,
    ...ChaptersReducerHandlers.addCommentToChapter,
    ...ChaptersReducerHandlers.addReplyToCommentInChapter,
    ...ChaptersReducerHandlers.updateReplyToCommentInChapter,
    ...ChaptersReducerHandlers.updateChapter,
    ...ChaptersReducerHandlers.updateCommentInChapter,
    ...ChaptersReducerHandlers.resolveCommentInChapter,
    ...ChaptersReducerHandlers.deleteCommentInChapter,
    ...ChaptersReducerHandlers.getDataToCompareVersions,
    ...ChaptersReducerHandlers.deleteOrUndoComments,
    ...ChaptersReducerHandlers.saveChaptersChanges,
    ...ChaptersReducerHandlers.fetchPhotosAndResources,
    ...ChaptersReducerHandlers.fetchProofDataByProjectId,
    ...ChaptersReducerHandlers.fetchProofDataByUserId,
    ...ChaptersReducerHandlers.wrapWithTagsAndSave,
    ...ChaptersReducerHandlers.generateClaudeReplyWithTranscript,
  },
);

export default chaptersReducer;
